import { useContext } from 'react'
import { TaskContext } from '../components/Tasks/TasksProvider'
export const useTasksContext = () => {
  return useContext(TaskContext)
}
